class Lightbox {
    element: JQuery = $('.js-lightbox');
    items: JQuery;

    constructor() {
        this.items = this.element.find('.js-item');
        this.items.each((index: number, item: HTMLElement) => {
            new LightboxItems($(item), this.items);
        });
    }
}

class LightboxItems {
    element: JQuery;
    allItems: JQuery;
    lightbox: JQuery = $('.c-lightbox');
    currentIndex: number;

    constructor(item: JQuery, allItems: JQuery) {
        this.element = item;
        this.allItems = allItems;
        this.currentIndex = this.element.index();

        if (!this.lightbox.length) return;
        this.element.find('.js-lightbox__inner').on('click', (e) => this.open(e));
    }

    private getTemplate(src: string, type: string, alt: string): string {
        // Added a loader div and a hidden state for the image initially
        if (type === 'video') {
            return `
                <div class='u-video c-lightbox__video'>
                    <iframe width='560' height='315' src='${src}' frameborder='0' allow='autoplay; encrypted-media' allowfullscreen></iframe>
                    <button class='c-lightbox__close c-btn mt-0 c-btn--no-icon c-btn--square'>
                        <span class="material-symbols-outlined">close</span>
                    </button>
                </div>`;
        }

        return `
            <div class='c-lightbox__imgwrapper'>
                <div class='c-lightbox__loader'></div>
                <img unselectable="on" class='c-lightbox__image' src='${src}' style='display: none;' />
                <button class='c-lightbox__close is-inline-block c-btn c-btn--primary p-1 mt-0' style="border-radius: 100% !important; display: inline-block !important; width: auto !important;">
                    <span class="material-symbols-outlined">close</span>
                </button>

            </div>
            <div class="columns is-justify-content-space-between">
            <div class="column is-1">
            <button class='c-btn c-lightbox__prev c-btn--primary mt-0'>
                <span class="material-symbols-outlined">navigate_before</span>
            </button>
            </div>
            <div class="column has-text-centered is-8">
            <figcaption>${alt}</figcaption>
            </div>
            <div class="column is-1">
            <button class='c-btn c-lightbox__next c-btn--primary mt-0'>
                <span class="material-symbols-outlined">navigate_next</span>
            </button>
            </div>
            </div>`;
    }

    open(event: JQuery.ClickEvent): void {
        event.preventDefault();
        this.currentIndex = this.element.index();
        this.render();
        this.lightbox.addClass('u-is-visible');
    }

    render(): void {
        const container = this.lightbox.find('.c-lightbox__inner');
        container.empty();

        const currentTarget = this.allItems.eq(this.currentIndex);
        const src = currentTarget.find('.js-lightbox__inner').attr('href') || '';
        const type = currentTarget.attr('data-type') || 'image';
        const alt =  currentTarget.find('.js-lightbox__inner').find("img").attr('alt') || '';


        container.append(this.getTemplate(src, type, alt));
        this.setupControls();
    }

    setupControls(): void {
        const nextBtn = this.lightbox.find('.c-lightbox__next');
        const prevBtn = this.lightbox.find('.c-lightbox__prev');
        const closeBtn = this.lightbox.find('.c-lightbox__close');
        const image = this.lightbox.find('.c-lightbox__image');
        const loader = this.lightbox.find('.c-lightbox__loader');
        const total = this.allItems.length;

        // Loading Logic: Show image and hide loader only when file is ready
        image.on('load', () => {
            loader.hide();
            image.fadeIn(200);
        });

        // Navigation visibility
        prevBtn.toggle(this.currentIndex > 0);
        nextBtn.toggle(this.currentIndex < total - 1);

        // Event cleaning
        closeBtn.off('click').on('click', () => this.close());
        nextBtn.off('click').on('click', () => this.navigate(1));
        prevBtn.off('click').on('click', () => this.navigate(-1));
        image.off('click').on('click', () => {
            if (this.currentIndex < total - 1) this.navigate(1);
        });
    }

    navigate(direction: number): void {
        const newIndex = this.currentIndex + direction;
        if (newIndex >= 0 && newIndex < this.allItems.length) {
            this.currentIndex = newIndex;
            this.render();
        }
    }

    close(): void {
        this.lightbox.removeClass('u-is-visible');
        this.lightbox.find('.c-lightbox__inner').empty();
    }
}

new Lightbox();
